// M004-F0745 section 6.1 - the drag ghost: a small stack of receipt cards (the dragged tile's picture on top) with a count badge when
// more than one receipt is being moved. Built as real DOM (the browser snapshots it for setDragImage), kept off-screen, attached while
// the drag lasts so a test can see it, and removed on drop / dragend.
export const DRAG_TYPE = 'application/x-studioaeye-receipts';

let current = null;

export const removeGhost = () => {
  if (current && current.parentNode) current.parentNode.removeChild(current);
  current = null;
};

export const buildGhost = ({ count, title, src }) => {
  removeGhost();
  const stack = Math.min(count, 3);
  const root = document.createElement('div');
  root.className = 'ew-ghost';
  root.setAttribute('data-testid', 'envelope-drag-ghost');
  root.setAttribute('data-stack', String(count));
  root.setAttribute('aria-hidden', 'true');
  for (let i = stack - 1; i >= 0; i -= 1) {
    const card = document.createElement('div');
    card.className = 'ew-ghost-card';
    card.style.transform = `translate(${i * 7}px, ${i * 7}px)`;
    if (i === 0) {
      if (src) {
        const img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.draggable = false;
        card.appendChild(img);
      }
      const label = document.createElement('span');
      label.className = 'ew-ghost-title';
      label.textContent = title;
      card.appendChild(label);
    }
    root.appendChild(card);
  }
  if (count > 1) {
    const badge = document.createElement('span');
    badge.className = 'ew-ghost-count';
    badge.setAttribute('data-testid', 'envelope-drag-ghost-count');
    badge.textContent = String(count);
    root.appendChild(badge);
  }
  document.body.appendChild(root);
  current = root;
  return root;
};
